const EnvironmentTypes = {
    local: "local",
    development: "development",
    production: "production",
}

class EnvironmentFactory {
    getEnvironment(environmentType) {
        switch (environmentType) {
            case EnvironmentTypes.local:
                return {
                    url: "http://localhost:9001/",
                    users: {
                        gerencia: 4,
                        administracion: 5,
                        contabilidad: 6,
                    },
                    version: "local"
                }
            case EnvironmentTypes.development:
                return {
                    url: "https://api-dev.epcmhub.com/",
                    users: {
                        gerencia: 4,
                        administracion: 5,
                        contabilidad: 6,
                    },
                    version: "dev"
                }
            case EnvironmentTypes.production:
                return {
                    url: "https://api.epcmhub.com/",
                    users: {
                        gerencia: 3,
                        administracion: 142,
                        contabilidad: 39,
                    },
                    version: "v5.8"
                }
        }
    }

}

const Environment = new EnvironmentFactory().getEnvironment(EnvironmentTypes.production)

export default Environment